import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as firebase from "firebase";
import { i18n } from "./plugins/i18n";

import currentUserApi from "@/api/currentuser/CurrentUser" ;

Vue.config.productionTip = false

const configOptions = {
  apiKey: "AIzaSyCTcS-DsUyVQSheluYv2qkLIS_iL6e2BJs",
  authDomain: "biogas-central.firebaseapp.com",
  databaseURL: "https://biogas-central.firebaseio.com",
  projectId: "biogas-central",
  storageBucket: "biogas-central.appspot.com",
  messagingSenderId: "211180707735",
  appId: "1:211180707735:web:6110af84f50d6f753d6ed2"
};

firebase.initializeApp(configOptions);

firebase.auth().onAuthStateChanged(function(user) {
  
  if (user) {
    
    store.commit("user/SET_USER", user) ;

    let api = new currentUserApi() ;
    api.get();
    
  }else{

    store.commit("user/SET_USER", { loggedin: false  }) ;
    router.replace({ name: "Login" });

  }

});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
